/**
 * PWA Install Prompt Component
 */

import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { Download, RefreshCw, X } from "lucide-react";
import { usePWA } from "@/hooks/usePWA";
import { useState } from "react";

export function PWAPrompt() {
  const { isInstallable, updateAvailable, promptInstall, reloadApp } = usePWA();
  const [showInstallPrompt, setShowInstallPrompt] = useState(true);
  const [showUpdatePrompt, setShowUpdatePrompt] = useState(true);

  if (!isInstallable && !updateAvailable) return null;

  if (updateAvailable && showUpdatePrompt) {
    return (
      <div className="fixed bottom-4 right-4 z-50 animate-in fade-in-0 zoom-in-95">
        <Card className="shadow-strong max-w-sm">
          <CardContent className="pt-6">
            <div className="flex items-start gap-3">
              <RefreshCw className="w-5 h-5 text-primary shrink-0 mt-0.5" />
              <div className="flex-1 space-y-2">
                <p className="text-sm font-medium">Nova versão disponível</p>
                <p className="text-xs text-muted-foreground">
                  Atualize para obter os recursos mais recentes
                </p>
                <div className="flex gap-2">
                  <Button size="sm" onClick={reloadApp} className="gradient-primary">
                    Atualizar
                  </Button>
                  <Button
                    size="sm"
                    variant="ghost"
                    onClick={() => setShowUpdatePrompt(false)}
                  >
                    Depois
                  </Button>
                </div>
              </div>
              <Button
                variant="ghost"
                size="icon"
                className="h-6 w-6 shrink-0"
                onClick={() => setShowUpdatePrompt(false)}
              >
                <X className="w-4 h-4" />
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (isInstallable && showInstallPrompt) {
    return (
      <div className="fixed bottom-4 right-4 z-50 animate-in fade-in-0 zoom-in-95">
        <Card className="shadow-strong max-w-sm">
          <CardContent className="pt-6">
            <div className="flex items-start gap-3">
              <Download className="w-5 h-5 text-primary shrink-0 mt-0.5" />
              <div className="flex-1 space-y-2">
                <p className="text-sm font-medium">Instalar aplicativo</p>
                <p className="text-xs text-muted-foreground">
                  Adicione à tela inicial para acesso rápido e offline
                </p>
                <div className="flex gap-2">
                  <Button
                    size="sm"
                    onClick={async () => {
                      const accepted = await promptInstall();
                      if (accepted) setShowInstallPrompt(false);
                    }}
                    className="gradient-primary"
                  >
                    Instalar
                  </Button>
                  <Button
                    size="sm"
                    variant="ghost"
                    onClick={() => setShowInstallPrompt(false)}
                  >
                    Não, obrigado
                  </Button>
                </div>
              </div>
              <Button
                variant="ghost"
                size="icon"
                className="h-6 w-6 shrink-0"
                onClick={() => setShowInstallPrompt(false)}
              >
                <X className="w-4 h-4" />
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  return null;
}
